import React, { useState, useEffect, useReducer } from 'react';
//import { withRouter } from "react-router";
import { Link, useParams, useNavigate } from 'react-router-dom'
import ScrollView from 'devextreme-react/scroll-view';
import _ from 'lodash'
import SelectBox from 'devextreme-react/select-box';
import { useSelector } from 'react-redux'
//import SelectBox from '../common/selectBox/SelectBox';
import Gallery from 'devextreme-react/gallery';
import Header from '../header/Header'
import Footer from '../footer/Footer'
import * as utils from '../../common/utils'
import * as actions from '../../actions/siteDetails';
import { postUserLog } from '../../actions/common'
import PrivateSite from '../common/PrivateSite'
import WeatherCard from '../common/weatherCard/WeatherCard';
import siteReducer from '../../reducers/siteDetails';
import UpcomingEvent from '../common/upcomingEventInTiles/UpcomingEvent';
import { Lookup, DropDownOptions } from 'devextreme-react/lookup';
import ScrollToTop from '../../ScrollToTop';
import config from '../../common/config';


const initialState = { siteLocations: [], locationList: [], userData: {}, pinSiteStatus: null, pinnedSites: [], siteInfo: null };
const SiteHome = (props) => {
    //const { match, history } = props
    //const { category, site } = match.params;
    const userData2 = useSelector(
        (state) => state.home.UserProfiledata
    );
    const { category, site } = useParams();
    const navigate = useNavigate()
    const [state, dispatch] = useReducer(siteReducer, initialState);
    const { siteLocations, pinnedSites, siteInfo, userData } = state;
    const siteApps = [{ id: 'digital', label: 'Digital Tier', name: 'Digital Tier', icon: 'digital' },
    { id: 'standardWork', label: 'Standard work', name: 'Standard work', icon: 'inventory' },
    { id: 'settings', label: 'Settings', name: 'Settings', icon: 'maintenance' },
    { id: 'rail', label: 'Rail', name: 'Rail', icon: 'action' },
    ]
    const [isPrivate, setIsPrivate] = useState(null)
    const [activeSite, setActiveSite] = useState(site)
    const [activeSiteWithSiteId, setActiveSiteWithSiteId] = useState(site)
    const [scrollConfig] = useState({
        showScrollbar: 'always',
        scrollByContent: true,
        scrollByThumb: true,
    });
    const [apps, setApps] = useState(siteApps);
    const [animate, setAnimate] = useState("");
    const award = [{
        title: "Best Employee Award",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Praesentium sed ex autem numquam earum voluptatibus tempora dolores tenetur explicabo quaerat nostrum, aspernatur necessitatibus corrupti ratione est repudiandae magni repellat hic?"
    },
    {
        title: "Best Employee Award",
        description: "Lorem ipsum dolor sit ",
    },
    {
        title: "Best Employee Award",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
    },
    {
        title: "Best Employee Award",
        description: "Lorem ipsum dolor sit "
    },
    {
        title: "Best Employee Award",
        description: "Lorem ipsum dolor sit amet consectetur adipisicing elit. "
    }
    ]
    const itemTemplate = (item) => {
        return (
            <div>
                <div className="title">{item.title}</div>
                <div className="description">{item.description}</div>
            </div>
        );
    };
    const initSiteHome = () => {
        actions.getUserData(dispatch, activeSite);
        actions.getSiteInfo(dispatch, activeSite);

        actions.fetchSiteLocations(dispatch, category);
        actions.fetchPinnedSites(dispatch, category);

        setTimeout(() => {
            setAnimate('animate')
        }, 250);
    };
    useEffect(() => {
        setActiveSite(site);

    }, [site]);

    useEffect(() => {
        initSiteHome();
    }, []);

    useEffect(() => {
        if (siteInfo) {
            setActiveSiteWithSiteId(`${siteInfo.siteName} (${siteInfo.siteId})`)

            if (!siteInfo.isPrivate)
                setIsPrivate(false)
            else if (siteInfo.isPrivate) {
                if (userData && userData.hId)
                    setIsPrivate(utils.isPrivateSite(userData, siteInfo))
            }
        }
    }, [siteInfo, userData])

    useEffect(() => {
        initSiteHome()
    }, [activeSite]);

    const filterApps = (e) => {
        let filterKey = e.target.value.toLowerCase().trim();
        setApps(filterKey ? _.filter(siteApps, (data) => data.name.toLowerCase().includes(filterKey)) : siteApps)
        postUserLog({ event: 'Search Apps', data: { action: 'Searched for ' + filterKey, module: 'Site Screen', section: 'Search Apps', siteUId: site, widget: '', } })
    }
    const navigateTo = (val) => {
        navigate("/home/" + val);
    }
    const getSitInfo = () => {
        let data = _.find(siteLocations, ['siteId', activeSite]);
        return data
    }
    const openStandardWork = () => {
        postUserLog({ event: 'Standard Work', data: { action: 'Opened Standard work in new tab', module: 'Site Screen', section: 'Standard Work', siteUId: site, widget: '', } });
        window.open(utils.STD_WORK_URL);
    }
    const getApps = () => {
        let apps = utils.getApps(state.userData)
        // console.log("322 apps in menuItems is ", apps.filter(menuItem => menuItem.id !== 'calendar' && menuItem.id !== 'standardWork'))
        let menuITems = apps.filter((menuItem) => menuItem.id !== 'calendar' && menuItem.id !== 'standardWork').map((data, i) => {
            let routeVal = 'tiers'
            if (data.id === 'settings')
                routeVal = data.id
            if (data.id === 'standardWork') {
                return (
                    <a onClick={openStandardWork} key={i}><div className="app">
                        <span className={"icon " + data.icon} ></span>
                        <span className="label">{data.name}</span>
                    </div>
                    </a >
                )
            }
            if (data.id == 'rail' || data.id == 'calendar')
                routeVal = 'siteApp'
            return (
                <Link to={`/${routeVal}/${category}/${activeSite}/${data.id}`} key={i} onClick={() => postUserLog({ event: 'Tier Selection', data: { action: routeVal + ' clicked', module: 'Site Home', section: 'Tier Selection', siteUId: site, widget: '', } })}><div className="app">
                    <span className={"icon " + data.icon} ></span>
                    <span className="label">{data.name}</span>
                    <ScrollToTop></ScrollToTop>

                </div>
                </Link >
            )
        }
        );
        if (config.DEV_DISPLAY_OPTIONS) {
            menuITems.push(<Link to={`/siteApp/${category}/${activeSite}/whiteboard`} key='wbw' onClick={() => postUserLog({ event: 'Tier Selection', data: { action: ' Whiteboard clicked', module: 'Site Home', section: 'Whiteboard', siteUId: site, widget: '', } })}><div className="app">
                <span className="icon whiteboard" ></span>
                <span className="label">Whiteboard</span>
                <ScrollToTop></ScrollToTop>

            </div>
            </Link >)
            menuITems.push(<Link to={`/siteApp/${category}/${activeSite}/kaizen`} key='kaizen' onClick={() => postUserLog({ event: 'Kaizen Selection', data: { action: ' Kaizen clicked', module: 'Site Home', section: 'Kaizen', siteUId: site, widget: '', } })}>
                {/* <div className="app">
                <span className="icon kaizenIdea" ></span>
                <span className="label" style={{ paddingTop: "5px" }}>Kaizen</span>
                <ScrollToTop></ScrollToTop>

            </div> */}
            </Link >)
        }
        
        return menuITems;
    }
    const updatePinSite = () => {
        let site = getSitInfo();
        let isPinned = site.isPinned ? false : true;
        let pinStatus = isPinned ? 'pinned' : 'unpinned';
        actions.updatePinSite(dispatch, `siteid=${site.siteId}&pinned=${isPinned}`, category);
        postUserLog({ event: 'Pin/UnPin Site', data: { action: site.siteName + ' site ' + pinStatus, module: 'Site Home', section: 'Header', siteUId: site.siteId, widget: 'Pinned Site', } })
    }
    const changeHandler = (event) => {
        let val = event.component.option('selectedItem');
        if (val) {
            actions.getUserData(dispatch, val.siteId);
            setActiveSiteWithSiteId(`${val.siteName} (${val.siteId})`)

            setActiveSite(val.siteId)
            postUserLog({ event: 'Site Changed', data: { action: 'Site changed to ' + val.siteName, module: 'Site Home', section: 'Select Site', siteUId: val.siteId, widget: '', } })
            event.value = activeSiteWithSiteId;
        }
    }

    const getAttr = (e) => {
        if (e) return `${e.siteName} (${e.siteUId})`;
    }
    return (
        <>
            {(isPrivate === false) &&
                <>
                    <Header showPinBtn={updatePinSite} site={getSitInfo()} />
                    <section className="page-content">
                        <div className="site-view">
                            <div className={"site-list " + animate}>
                                <div className="site-head">
                                    <div className="page-heading">
                                        <h2 className="pointer" style={{ cursor: "auto" }}><span style={{ display: "flex", alignItems: "center", cursor: "pointer" }} onClick={() => navigateTo(category)}><span className={"icon icon-" + utils.getSbgName(category)}></span>{utils.getSbgNameTxt(category)}</span></h2>
                                    </div>
                                    <div className="lookup-sites">
                                        <div className="dx-field">
                                            <div className="dx-field-value">
                                                <div id="selectSitesLookup">
                                                    <Lookup
                                                        items={siteLocations}
                                                        displayExpr={(e) => getAttr(e)}
                                                        value={activeSiteWithSiteId}
                                                        placeholder={activeSiteWithSiteId}
                                                        onValueChanged={(e) => changeHandler(e)}
                                                        showCancelButton={false}
                                                    >
                                                        <DropDownOptions
                                                            hideOnOutsideClick={true}
                                                            showTitle={false}
                                                        />
                                                    </Lookup>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className="search">
                                        <div className="form-group">
                                            <input onChange={filterApps} type="text" placeholder="Search Apps" />
                                            <span className="icon search-icon"></span>
                                        </div>
                                    </div> */}
                                </div>
                                <div className="site-body">
                                    <ScrollView
                                        id="sitecontent"
                                        {...scrollConfig}
                                    >
                                        <div className="site-body">
                                            {
                                                getApps()
                                            }
                                        </div>
                                    </ScrollView>
                                </div>
                            </div>
                            {/*< !--widgets container -->*/}
                            <ScrollView
                                id="sitecontentright"
                                {...scrollConfig}
                            >
                                <div className="widgets-wrap scroll">
                                    {/*< !--weather -->*/}
                                    <UpcomingEvent site={getSitInfo()} />
                                    {
                                        //<>
                                        //    <div className={"card mail " + animate}>
                                        //        <div className="img-wrap">
                                        //            <div className="icon mail-icon"></div>
                                        //        </div>
                                        //        <div className="slider-wrap">

                                        //            <Gallery
                                        //                dataSource={award}
                                        //                height={64}
                                        //                loop={true}
                                        //                showIndicator={true}
                                        //                itemRender={itemTemplate}
                                        //            />
                                        //        </div>


                                        //    </div>
                                        //</>
                                    }
                                    {
                                        //<>
                                        //    <div className={"card calendar " + animate}>
                                        //        <div className="img-wrap">
                                        //            <div className="icon calendar-icon"></div>
                                        //        </div>
                                        //        <div className="slider-wrap">
                                        //            <div id="event">8:00 AM Weekly Program</div>
                                        //            <div id="event">10:00 AM microsoft meeting</div>
                                        //        </div>
                                        //    </div>

                                        //    <div className={"card " + animate}>
                                        //    </div>
                                        //    <div className={"card " + animate}>
                                        //    </div>
                                        //    <div className={"card " + animate}>
                                        //    </div>
                                        //</>
                                    }
                                </div>
                            </ScrollView>
                        </div>
                    </section>
                    <Footer showThemeSwitch={true} hideSiteCount={true} activeSites={pinnedSites} sbg={category} />
                </>
            }
            {isPrivate && <section className="page-content"><PrivateSite site={siteInfo} /></section >}
        </>
    );
}
export default SiteHome
//export default withRouter(SiteHome)